// src/utils.js - Utilidades globales compartidas ERP Taller Vargas

export function safeFormatDate(dateVal, options) {
  if (options === undefined) options = { day: '2-digit', month: 'short', year: 'numeric' };
  if (!dateVal) return '—';
  var parsedDate;
  if (typeof dateVal === 'string') {
    parsedDate = dateVal.includes('T') ? new Date(dateVal) : new Date(dateVal + 'T12:00:00');
  } else {
    parsedDate = new Date(dateVal);
  }
  if (isNaN(parsedDate.getTime())) return '—';
  return parsedDate.toLocaleDateString('es-PE', options);
}

export function safeFormatDateTime(dateVal) {
  if (!dateVal) return '—';
  var parsedDate;
  if (typeof dateVal === 'string') {
    parsedDate = dateVal.includes('T') ? new Date(dateVal) : new Date(dateVal + 'T12:00:00');
  } else {
    parsedDate = new Date(dateVal);
  }
  if (isNaN(parsedDate.getTime())) return '—';
  var dateStr = parsedDate.toLocaleDateString('es-PE', { day: 'numeric', month: 'long', year: 'numeric' });
  var timeStr = parsedDate.toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit', hour12: true });
  return dateStr + ' ' + timeStr;
}

export function debounce(fn, ms) {
  if (ms === undefined) ms = 300;
  var timer;
  return function() {
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function() { fn.apply(null, args); }, ms);
  };
}

export function formatCurrency(value) {
  var num = parseFloat(value) || 0;
  return 'S/ ' + num.toFixed(2);
}

export function escapeHtml(str) {
  if (str === null || str === undefined) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/**
 * Imprime contenido HTML usando el contenedor global #print-area sin hojas en blanco
 * @param {string} html - Código HTML estructurado a imprimir
 */
export function imprimirHtmlDirecto(html) {
  let printArea = document.getElementById('print-area');
  if (!printArea) {
    printArea = document.createElement('div');
    printArea.id = 'print-area';
    document.body.appendChild(printArea);
  }
  printArea.innerHTML = html;

  const onAfter = () => {
    printArea.innerHTML = '';
    window.removeEventListener('afterprint', onAfter);
  };
  window.addEventListener('afterprint', onAfter);

  setTimeout(() => {
    window.print();
    setTimeout(() => {
      printArea.innerHTML = '';
    }, 2500);
  }, 100);
}

if (typeof window !== 'undefined') {
  window.imprimirHtmlDirecto = imprimirHtmlDirecto;
}

export function normalizePlate(p) {
  return (p || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
}

/**
 * Parsea JSON de manera segura evitando excepciones no controladas
 */
export function safeJsonParse(val, fallback = null) {
  if (val === null || val === undefined) return fallback;
  if (typeof val === 'object') return val;
  try {
    return JSON.parse(val);
  } catch (_) {
    return fallback;
  }
}

